import axios, { AxiosError } from "axios";

import { API_ENDPOINT } from "../config";

export const axiosMiddleware = () => {
  axios.interceptors.request.use(function (config) {
    config.baseURL = API_ENDPOINT;
    config.withCredentials = true;
    // Axios default timeout is 0 (no timeout). Apply our 30s app default
    // unless the caller sets an explicit positive timeout (bulk ops, etc.).
    if (!config.timeout) {
      config.timeout = 30000;
    }
    return config;
  });
  axios.interceptors.response.use((response) => response, manageErrorConnection);
};

function manageErrorConnection(err: AxiosError) {
  return Promise.reject(err);
}

export default axios;
